module.exports = __webpack_public_path__ + "static/image/main/pc/banner-5-1.ver2_0_2.jpg?22e9dc13";